import { useTranslation } from 'react-i18next';
import { BasePopover, Icon, Tooltip, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { LabelCreator } from '@hotjar/labels';

const AddButton = styled(Icon)`
  ${tokens.transition()};
  cursor: pointer;

  &:hover {
    transform: scale(1.2);
  }
`;

const StyledPopover = styled(BasePopover)`
  padding: 0px;
  .tippy-box {
    padding: 0px;
  }
  .tippy-content {
    padding: 0px;
  }
`;

interface Props {
  siteId: string | null;
}

export const AddCustomLabelButton = ({ siteId }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Tooltip text={t('highlights:popover.add-label')}>
      <StyledPopover withCloseButton={false} content={<LabelCreator siteId={siteId ?? null} />}>
        <div data-testid="Add label">
          <AddButton icon="plus" />
        </div>
      </StyledPopover>
    </Tooltip>
  );
};
